import VueX from '@/store';
const Franchise = () => import('@/modules/franchise');

export default [
  {
    path: '/franquias/:id',
    name: 'franchise',
    component: Franchise,
    meta: {
      navbarTitle: () => VueX.getters['franchise/actual'].name,
      nameCity: true,
    },
  },
  {
    path: '/franquia/config/',
    // path: '/franquia/config/:id', TODO: Mudar quando franquia ser implementada
    name: 'franchise-config',
    component: Franchise,
    props: true,
    meta: {
      showSidebar: false,
      navbarTitle: 'Configurações',
      isAvaliableInMenu: false, // PDME-119 Ocultado no menu
      menuData: {
        title: 'Franquia',
        id: 'franchiseSidebar',
      },
    },
  },
];
